// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as api from 'syft-acp-core/api/resources/admin/employers/ratings'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('EMPLOYER_RATINGS_FETCH', api.listEmployerRatings)
}
